import { SwiperGallery } from './SwiperGallery'


import itWasImage1 from '../assets/it-was/1.jpg';
import itWasImage2 from '../assets/it-was/2.jpg';
import itWasImage3 from '../assets/it-was/3.jpg';
import itWasImage4 from '../assets/it-was/4.jpg';
import itWasImage5 from '../assets/it-was/5.jpg';
import itWasImage6 from '../assets/it-was/6.jpg';
import itWasImage7 from '../assets/it-was/7.jpg';
import itWasImage8 from '../assets/it-was/8.jpg';
import itWasImage9 from '../assets/it-was/9.jpg';
import itWasImage10 from '../assets/it-was/10.jpg';
import itWasImage11 from '../assets/it-was/11.jpg';
import itWasImage12 from '../assets/it-was/12.jpg';
import itWasImage13 from '../assets/it-was/13.jpg';
import itWasImage14 from '../assets/it-was/14.jpg';
import itWasImage15 from '../assets/it-was/15.jpg';

/* cекция как это было */
export function ItWas() {
    /* Массив изображений для галереи в секции "как это было" */
    const itWasGalleryImages = [
        { src: itWasImage1, alt: '1' },
        { src: itWasImage2, alt: '2' },
        { src: itWasImage3, alt: '3' },
        { src: itWasImage4, alt: '4' },
        { src: itWasImage5, alt: '5' },
        { src: itWasImage6, alt: '6' },
        { src: itWasImage7, alt: '7' },
        { src: itWasImage8, alt: '8' },
        { src: itWasImage9, alt: '9' },
        { src: itWasImage10, alt: '10' },
        { src: itWasImage11, alt: '11' },
        { src: itWasImage12, alt: '12' },
        { src: itWasImage13, alt: '13' },
        { src: itWasImage14, alt: '14' },
        { src: itWasImage15, alt: '15' },
    ];

    return (
        <section className='it-was'>
            <div className='container'>
                <h2 className='section-title scroll-reveal'>Как это было</h2>
            </div>
            <SwiperGallery images={itWasGalleryImages} />
        </section>
    )
}
